﻿(function (document, window) {
    document.querySelectorAll('[data-ajax-submit]').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            if (button.dataset.validationGroup && !window.ValidateIodineGroup(button.dataset.validationGroup)) {
                return;
            }

            var url = button.dataset.ajaxSubmit;
            var method = button.dataset.ajaxMethod || 'POST';
            var form = button.dataset.ajaxForm;
            var onSubmit = button.dataset.ajaxOnSubmit;

            var data = {};
            document.querySelectorAll('[data-ajax-form="' + form + '"]:not([data-ajax-submit])').forEach(function (input) {
                data[input.dataset.ajaxFieldName] = input.value;
            });

            if (onSubmit) {
                window[onSubmit]();
            }

            fetch(
                url,
                {
                    method: method,
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                }
            ).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (document.querySelector('body').classList.contains('kss-body')) {
                    console.log('Result from submission', data);
                } else {
                    window.location.href = data.RedirectUrl;
                }
            });
        });
    });

    document.querySelectorAll('[data-ajax-default-button]').forEach(function (form) {
        var button = document.querySelector(form.dataset.ajaxDefaultButton);

        form.querySelectorAll('input').foreach(function (input) {
            input.addEventListener("keyup", function (e) {
                if (event.keyCode === 13) {
                    e.preventDefault();
                    button.click();
                }
            });
        });
    });

})(document, window);